export enum ENERGY_CLASS {
    HIGH = 1,
    MEDIUM,
    LOW
}